import React from 'react'
import { MenuItem } from '@mui/material'

import { NewB2BFormState } from '../../qrs.types.ts'
import { SelectFieldControl } from '../../../../components/form'
import { useAppSelector } from '@/stores/hooks.ts'

export const MerchantField = (): React.ReactElement => {
  const tspList = useAppSelector((state) => state.user.user?.tspList ?? [])
  return (
    <SelectFieldControl<NewB2BFormState> name="merchantId" fullWidth label="ТСП">
      {tspList.map((tsp) => (
        <MenuItem key={tsp.merchantId} value={tsp.merchantId}>
          {tsp.name}
        </MenuItem>
      ))}
    </SelectFieldControl>
  )
}
